module.exports = __webpack_public_path__ + "static/media/off.dce048e9.png";